export enum OHIFVersions {
  v3_9_0 = 'v3.9.0',
  v3_11_0 = 'v3.11.0',
}
